import OrderFormService from "@/services/orderForm.service.js";
// import store from "@/stores/index.js";

export default class OrderUsecase {
  constructor () {
    this.orderFormService = new OrderFormService();
  }
  getWriteString () {
    return this.orderFormService.write;
  }
  getCarveString () {
    return this.orderFormService.carve;
  }
  getFontsForCarve () {
    return this.orderFormService.fontsForCarve;
  }
  getFontsAll () {
    return this.orderFormService.fontsAll;
  }
  getPrintTypes () {
    return this.orderFormService.printTypes;
  }
  getPrintTypeLabelByValue (value) {
    if (value !== undefined) {
      return this.orderFormService.printTypes.filter(
        el => el.value === value
      )[0].label;
    } else {
      return "";
    }
  }
  getColorsForFront () {
    return this.orderFormService.colorsForFront;
  }
  getFrontColorLabelByValue (value) {
    if (value !== undefined) {
      return this.orderFormService.colorsForFront.filter(
        el => el.value === value
      )[0].label;
    } else {
      return "";
    }
  }
  getColorsForBack () {
    return this.orderFormService.colorsForBack;
  }
  getBackColorLabelByValue (value) {
    if (value !== undefined) {
      return this.orderFormService.colorsForBack.filter(
        el => el.value === value
      )[0].label;
    } else {
      return "";
    }
  }
  getSects () {
    return this.orderFormService.sects;
  }
  getDiedCharacters () {
    return this.orderFormService.diedCharacters;
  }
  getAgeAtDeathPrefixes () {
    return this.orderFormService.ageAtDeathPrefixes;
  }
  getAgeUnitCharacters () {
    return this.orderFormService.ageUnitCharacters;
  }
  getSecularNameSuffixes () {
    return this.orderFormService.listSecularNameSuffixes();
  }
  getBuddhistNameCodes (param) {
    return this.orderFormService.listBuddhistNameCodes(param);
  }
}
